var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",class:{'is-selected': _vm.isSelected, 'has-actions': _vm.hasActions}},[_vm._t("default"),(_vm.hasActions)?_c('core-list-cell-actions',{staticClass:"card-actions",attrs:{"item":_vm.item,"filter":"plays","horizontal":true}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }